export function transformAddresses(inputData) {
  return inputData.map((item) => {
    const addressType = item["address_type"]?.toLowerCase() || "house";
    
    // Build address-specific details based on type
    let houseName = "";
    let buildingNumber = "";
    let floor = "";
    
    if (addressType === "apartment") {
      // For apartments: show building, floor, and apartment number
      houseName = item["building"] ? `Building: ${item["building"]}` : "";
      buildingNumber = item["street"] && item["block"] ? `Street: ${item["street"]}, Block: ${item["block"]}` : "";
      floor = `Floor: ${item["floor"] || "-"}, Apt: ${item["apartment_no"] || "-"}`;
    } else if (addressType === "office") {
      // For offices: show company name, building, and floor
      houseName = item["company_name"] ? `${item["company_name"]}` : "";
      buildingNumber = item["building"] ? `Building: ${item["building"]}, Floor: ${item["floor"] || "-"}` : "";
      floor = item["street"] && item["block"] ? `Street: ${item["street"]}, Block: ${item["block"]}` : "";
    } else {
      // For houses: show house number, street, and block
      houseName = item["house_no"] ? `House no: ${item["house_no"]}` : "";
      buildingNumber = item["street"] && item["block"] ? `Street: ${item["street"]}, Block: ${item["block"]}` : "";
      floor = item["avenue"] ? `Avenue: ${item["avenue"]}` : "";
    }
    
    return {
      id: item["id"],
      address_type: item["address_type"], // Preserve the original address_type
      firstLine:
        item["address_type"].charAt(0).toUpperCase() +
        item["address_type"].slice(1),
      houseName: houseName,
      buildingNumber: buildingNumber,
      floor: floor,
      number: item["phone_no"]
        ? `${item["phone_country_code"]}${item["phone_no"]}`
        : "",
      area: item["delivery_charge_area_name_en"],
      area_id: item["area_id"], // Preserve area ID for matching with area charges
      active_order: item["active_order"] || false,
    };
  });
}

export const saveAddressPayload = (input) => {
  return {
    address_type: (input.address_type || "").toLowerCase(),
    country_id: input.country_id || "3",
    restaurant_id: input.restaurant_id || "2",
    branch_id: input.branch_id || "5",
    delivery_charge_area_name_en: input.area || "",
    block: input.block || "",
    street: input.street || "",
    additional_direction: input.additionalDirections || "",
    country_code: input.country_code || "+965",
    mobile_number: input.alternativePhone || "",
    house_no: input.houseNumber || "",
    apartment_no: input.apartmentNo || "",
    building: input.building || "",
    floor: input.floor || "",
    company_name: input.companyName || "",
    avenue: input.avenue || "",
    address_label: input.addressLabel || "",
    latitude: input.latitude || "",
    longitude: input.longitude || "",
    customer_id: input.customerId,
  };
};

export const formFields = {
  House: [
    // {
    //   placeholder: "Governance (Required)",
    //   name: "governance",
    //   className: "placeholder-black",
    // },
    {
      placeholder: "Block (Required)",
      name: "block",
    },
    { placeholder: "Street (Required)", name: "street" },
    { placeholder: "Avenue (Optional)", name: "avenue" },
    { placeholder: "House Number (Required)", name: "houseNumber" },
    { placeholder: "Address Label (Optional)", name: "addressLabel" },
  ],
  Apartment: [
    // {
    //   placeholder: "Governance (Required)",
    //   name: "governance",
    //   className: "placeholder-black",
    // },
    {
      placeholder: "Block (Required)",
      name: "block",
    },
    { placeholder: "Street (Required)", name: "street" },
    { placeholder: "Avenue (Optional)", name: "avenue" },
    { placeholder: "Building (Required)", name: "building" },
    { placeholder: "Floor (Required)", name: "floor" },
    { placeholder: "Apartment No (Required)", name: "apartmentNo" },
    { placeholder: "Address Label (Optional)", name: "addressLabel" },
  ],
  Office: [
    // {
    //   placeholder: "Governance (Required)",
    //   name: "governance",
    //   className: "placeholder-black",
    // },
    {
      placeholder: "Block (Required)",
      name: "block",
    },
    { placeholder: "Street (Required)", name: "street" },
    { placeholder: "Avenue (Optional)", name: "avenue" },
    { placeholder: "Building (Required)", name: "building" },
    { placeholder: "Floor (Required)", name: "floor" },
    { placeholder: "Company Name (Required)", name: "companyName" },
    { placeholder: "Address Label (Optional)", name: "addressLabel" },
  ],
};
